const apiUrl = process.env.REACT_APP_API_URL;

export interface TelemetriaFitxer {
    nom: string;
    contingut: string;
}

export interface TelemetriaProgresPayload {
    idUsuari: number | string;
    idProblema?: number | string | null;
    idPractica?: number | string | null;
    isExamen?: number; // 0/1
    origen?: string;   // 'ide_integrat' | 'ide_desafio'
    progres?: number | null;
    tipus?: string | null;
    editorActual?: string | null;
    fitxers?: string | null; // JSON stringificat de TelemetriaFitxer[]
}

/**
 * Desa una foto de telemetria (progrés + fitxers) de l'alumne per a un exercici.
 */
export const PostTelemetriaProgres = async (payload: TelemetriaProgresPayload): Promise<boolean> => {
    try {
        const token = localStorage.getItem('authToken');
        const res = await fetch(`${apiUrl}:8061/bbdd/telemetria/progres`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            },
            body: JSON.stringify(payload)
        });
        return res.ok;
    } catch (error) {
        console.error('Error desant telemetria de progrés:', error);
        return false;
    }
};

/**
 * Recupera les telemetries de progrés (per al dashboard del professor).
 */
export const GetTelemetriaProgres = async (idProblema?: number | string, idUsuari?: number | string, idPractica?: number | string) => {
    try {
        const params = new URLSearchParams();
        if (idProblema !== undefined && idProblema !== null && idProblema !== '') params.append('idProblema', String(idProblema));
        if (idUsuari !== undefined && idUsuari !== null && idUsuari !== '') params.append('idUsuari', String(idUsuari));
        if (idPractica !== undefined && idPractica !== null && idPractica !== '') params.append('idPractica', String(idPractica));
        const token = localStorage.getItem('authToken');
        const res = await fetch(`${apiUrl}:8061/bbdd/telemetria/progres?${params.toString()}`, {
            headers: { ...(token ? { 'Authorization': `Bearer ${token}` } : {}) }
        });
        if (!res.ok) return [];
        return await res.json();
    } catch (error) {
        console.error('Error llegint telemetria de progrés:', error);
        return [];
    }
};
